import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import firebase from 'firebase'
import VueCookie from 'vue-cookie'
import PortalVue from 'portal-vue'
import VueMq from 'vue-mq'
// import vueSmoothScroll from 'vue2-smooth-scroll' // EI ONNISTU TOIMIMAAN -> POISTETAANKO KOKONAAN?

Vue.config.productionTip = false

Vue.use(VueCookie)
Vue.use(PortalVue)
Vue.use(VueMq, {
  breakpoints: {
    phone: 550,
    tablet: 900,
    others: Infinity
  }
})

// TARKISTAA AINA REFRESHIN JÄLKEEN, ONKO KÄYTTÄJÄ JO KIRJAUTUNUT -> COOKIE!!!
let app = null
firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
})

/* TÄMÄ ON ALKUPERÄINEN */
/* new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app') */
